import { useContext, useState } from 'react';
import { ActionButton } from '@components/button/action-button';
import { ActionButtonModal } from '@components/modals/action-button-modal';
import { XS_VIEWPORT } from '@constants/viewport';
import { ActionModalType } from '@contexts/modal/modal.type';
import { ModalContext } from '@contexts/modal/modal-context';
import { Menu, MenuButton } from '@headlessui/react';
import { useWindowSize } from '@hooks/use-window-size';

import { defaultTransitonProps } from '../layout/constants';

import { MenuButtonActionOptions } from './components/menu-button-action-options';
import { MenuButtonActionsProps } from './menu-button-actions.type';

export const MenuButtonActions = ({
  navigateToCreateEvent,
  createEventDisabledReason,
  transitionProps = defaultTransitonProps,
  label,
  customClassNames = '',
  actionButtonCustomClasses,
  actions,
}: MenuButtonActionsProps) => {
  const { toggleModal } = useContext(ModalContext);
  const [openActionModal, setOpenActionModal] = useState(false);
  const isMobileViewPort = useWindowSize(XS_VIEWPORT);
  const onClickActionItemButton = (key: ActionModalType) => {
    toggleModal({ type: key });
  };
  if (isMobileViewPort)
    return (
      <>
        <ActionButton
          label={label}
          customClasses={actionButtonCustomClasses}
          onClick={() => setOpenActionModal(true)}
        />
        <ActionButtonModal
          setIsOpen={setOpenActionModal}
          open={openActionModal}
          toggleModal={toggleModal}
          actions={actions}
          navigateToCreateEvent={navigateToCreateEvent}
          createEventDisabledReason={createEventDisabledReason}
        />
      </>
    );
  return (
    <Menu>
      {({ open }) => (
        <>
          <MenuButton as='div' className={customClassNames}>
            <ActionButton label={label} customClasses={actionButtonCustomClasses} />
          </MenuButton>
          <MenuButtonActionOptions
            transitionProps={transitionProps}
            open={open}
            actions={actions}
            onClickActionItemButton={onClickActionItemButton}
            navigateToCreateEvent={navigateToCreateEvent}
            createEventDisabledReason={createEventDisabledReason}
          />
        </>
      )}
    </Menu>
  );
};
